import { Directive, HostListener} from '@angular/core';

@Directive({
  // tslint:disable-next-line:directive-selector
  selector: '[cleanInputOnfocus]'
})
export class CleanInputOnfocusDirective {
  constructor() { }
  @HostListener('focus', ['$event'])
  onFocus(event) {
    event.target.value = '';
  }
}

